import { api } from "@/modules/api";
import { getBackendApiErrorMessage } from "@/modules/api/errorHandling";
import type {
  AcceptSharedAgentSkill,
  AgentSkillShare,
  SharedAgentSkill,
} from "@/pages/agent/skills/agent-skill.types";

function unwrap<T>({ data, error }: { data?: T; error?: unknown }, fallbackMessage: string): T {
  if (error || data === undefined) {
    throw new Error(getBackendApiErrorMessage(error) ?? fallbackMessage);
  }
  return data;
}

export const shareAgentSkill = async (id: string): Promise<AgentSkillShare> => {
  const response = await api.post("/v2/mem-agent-skills/{skill_id}/share", {
    params: { path: { skill_id: id } },
  });
  return unwrap(response, "Unable to share skill");
};

export const unshareAgentSkill = async (id: string): Promise<void> => {
  const response = await api.delete("/v2/mem-agent-skills/{skill_id}/share", {
    params: { path: { skill_id: id } },
  });
  if (response.error) {
    throw new Error(getBackendApiErrorMessage(response.error) ?? "Unable to revoke the link");
  }
};

export const getSharedAgentSkill = async (publicId: string): Promise<SharedAgentSkill> => {
  const response = await api.get("/v2/mem-agent-skills/shared/{public_id}", {
    params: { path: { public_id: publicId } },
  });
  return unwrap(response, "This shared skill is no longer available");
};

export const acceptSharedAgentSkill = async (
  publicId: string
): Promise<AcceptSharedAgentSkill> => {
  const response = await api.post("/v2/mem-agent-skills/shared/{public_id}/accept", {
    params: { path: { public_id: publicId } },
  });
  return unwrap(response, "Unable to import skill");
};
